import { HTMLAttributes, useEffect } from "react";
import { useStores } from "../../stores";
import { HEADER_TYPE } from "../../constants";
import { ContainerGridBlock } from "../../components/common/ContainerGrid/ContainerGrid.styled";
import { Star } from "./Star";
import { Title } from "./Title";
import { Instruments } from "./Instruments";
import { Divider } from "./Divider";
import { Period } from "./Period";
import { Plans } from "./Plans";
import { Goods } from "./Goods";
import { loadStripe } from "@stripe/stripe-js";
import { API } from "../../core";
import { observer } from "mobx-react";

type PricingActualPageProps = HTMLAttributes<HTMLElement>;

export const PricingActualPage = observer(({}: PricingActualPageProps) => {
	const { settingsStore, stripeStore, pricingActualStore, shopGoodsStore } = useStores();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
		settingsStore.setIsWhiteMain(true);

		return () => {
			settingsStore.setIsWhiteMain(false);
		};
	}, []);

	/**
	 * Stripe JS
	 */
	useEffect(() => {
		(async () => {
			const result = await loadStripe(API.stripeKey);

			if (result) {
				stripeStore.setInstance(result);
			}
		})();
	}, []);

	/**
	 * Получение товаров в зависимости от выбранных фильтрах
	 */
	useEffect(() => {
		(async () => {
			// Записываем фильтры
			shopGoodsStore.filter.set("shop_good_plans_id", 1);
			shopGoodsStore.filter.set("shop_good_period_id", 1);
			shopGoodsStore.filter.set("instrument_id", pricingActualStore.instrument_id);

			// Получение товаров
			await shopGoodsStore.getList();
		})();
	}, []);

	/**
	 * При изменении инструмента, периода, плана обновляем данные
	 */
	useEffect(() => {
		(async () => {
			console.log("filter data", pricingActualStore);

			shopGoodsStore.filter.set("shop_good_plans_id", pricingActualStore.plan_id);
			shopGoodsStore.filter.set("shop_good_period_id", pricingActualStore.period_id);
			shopGoodsStore.filter.set("instrument_id", pricingActualStore.instrument_id);

			await shopGoodsStore.getList();
		})();
	}, [pricingActualStore.instrument_id, pricingActualStore.period_id, pricingActualStore.plan_id]);

	return (
		<>
			<ContainerGridBlock width={1170} style={{ userSelect: "none" }}>
				<Star />
				<Title />
				<Instruments />
				<Divider />
				<Period />
				<Plans />
				<Goods />
			</ContainerGridBlock>

			{/*<Include />*/}
		</>
	);
});
